import React from "react";
import { Box, Card, CardContent, Container, Grid } from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";

function RosterList() {
    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                <Grid item xs={12}>
                    <Card className="card">
                        <CardContent>
                            <Box className="card-content">...</Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

export default RosterList;
